
import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import AppShell from "@/components/AppShell";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { SETTINGS } from "@/constants/testIds";

const FIELDS = [
  { key: "price_per_inch", label: "Channel Letters — $ / inch", testid: SETTINGS.pricePerInch, hint: "Per inch of letter height" },
  { key: "installation",   label: "Installation default",       testid: SETTINGS.installation },
  { key: "permit",         label: "Permit default",             testid: SETTINGS.permit },
  { key: "electrical",     label: "Electrical default",         testid: SETTINGS.electrical },
  { key: "raceway",        label: "Raceway default",            testid: SETTINGS.raceway },
  { key: "removal",        label: "Removal of old sign default",testid: SETTINGS.removal },
  { key: "misc",           label: "Miscellaneous default",      testid: SETTINGS.misc },
];

export default function Settings() {
  const [s, setS] = useState(null);
  const [saving, setSaving] = useState(false);

  
  useEffect(() => {
    
    (async () => {
      try { const { data } = await api.get("/settings"); setS(data); }
      catch { toast.error("Failed to load settings"); }
    })();
  }, []);

  const save = async () => {
    if (!s) return;
    setSaving(true);
    try {
      const payload = Object.fromEntries(FIELDS.map(f => [f.key, parseFloat(s[f.key] || 0) || 0]));
      const { data } = await api.put("/settings", payload);
      setS(data);
      toast.success("Pricing defaults saved");
    } catch { toast.error("Save failed"); }
    finally { setSaving(false); }
  };

  return (
    <AppShell>
      <div data-testid={SETTINGS.page} className="max-w-3xl enter-up">
        <div className="label-tag mb-2">Admin</div>
        <h1 className="font-heading text-4xl font-black tracking-tight">Pricing Defaults</h1>
        <p className="text-zinc-500 mt-2 max-w-xl">
          These values pre-fill every new quote. You can still override pricing per project inside the workspace.
        </p>

        <div className="mt-8 surface-card rounded-md p-6">
          {!s ? (
            <div className="space-y-3">
              {FIELDS.map(f => <div key={f.key} className="h-12 bg-zinc-900/60 rounded animate-pulse" />)}
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              {FIELDS.map((f) => (
                <div key={f.key}>
                  <Label className="label-tag">{f.label}</Label>
                  <div className="mt-1.5 relative">
                    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-500 text-sm">$</span>
                    <Input
                      data-testid={f.testid}
                      type="number"
                      step="0.01"
                      className="bg-[#0c0c0e] border-zinc-800 pl-7 font-mono"
                      value={s[f.key]}
                      onChange={(e) => setS({ ...s, [f.key]: e.target.value })}
                    />
                  </div>
                  {f.hint && <div className="text-[11px] text-zinc-600 mt-1">{f.hint}</div>}
                </div>
              ))}
            </div>
          )}

          <div className="mt-8 flex justify-end">
            <Button data-testid={SETTINGS.saveBtn} disabled={saving || !s} onClick={save} className="bg-brand hover:bg-brand-hover">
              {saving ? "Saving…" : "Save defaults"}
            </Button>
          </div>
        </div>
      </div>
    </AppShell>
  );
}
